const initState = {
    userInputs: [
        {
            timestamp: new Date(),
            group: "BIG DATA",
            tag: "volume",
        },
        {
            timestamp: new Date(),
            group: "BIG DATA",
            tag: "informação"
        },
        {
            timestamp: new Date(),
            group: "BIG DATA",
            tag: "insight"
        },
        {
            timestamp: new Date(),
            group: "BIG DATA",
            tag: "✨"
        }
        ,
        {
            timestamp: new Date(),
            group: "BIG REVOLUTION",
            tag: "✨"
        }
    ]

};
const userInputReducer = (state = initState, action) => {
    switch(action.type) {
        case "CREATE_USER_INPUT":
            console.log("CREATE_USER_INPUT");
            return state

        case "CREATE_INPUT_ERROR":
            console.log("create input error", action.err);
            return state
            
        default: return state
            
    }
};

export default userInputReducer;